module.exports = __webpack_public_path__ + "c0bc9e157b9d391dcc6f12e606592fdb.svg";